__turbopack_context__.v({
  "container": "HeroSection-module-scss-module__7Fc7TG__container",
  "content": "HeroSection-module-scss-module__7Fc7TG__content",
  "description": "HeroSection-module-scss-module__7Fc7TG__description",
});
